import { Link } from "react-router-dom";
import { RiArrowDownSLine } from "react-icons/ri";
import { FaAngleRight, FaArrowRight } from "react-icons/fa6";
import { useState, useRef, useEffect } from "react";
import "./header.css";
import "./navMobile.css";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

function SubItemSelect({ text, onClick }) {
  return (
    <li onClick={onClick} className="dd-item dd-item--center">
      {text}
    </li>
  );
}

function SubItem({ text, link, onNavigate, removeArrow }) {
  return (
    <li className="dd-item">
      <Link to={link} onClick={onNavigate}>
        <span>{text}</span>
      </Link>
      {!removeArrow && <FaAngleRight className="dd-arrow" />}
    </li>
  );
}
// function MegaSubItem({ text, link, onNavigate, removeArrow }) {
//   return (
//     <li className="mega-menu-item">
//       <Link to={link} onClick={onNavigate}>
//         <span>{text}</span>
//       </Link>
//       {!removeArrow && <FaAngleRight className="dd-arrow" />}
//     </li>
//   );
// }
function MegaSubItem({ text, link, onNavigate, removeArrow }) {
  const handleClick = (e) => {
    e.preventDefault();

    onNavigate?.();

    window.location.reload();

    // Better: navigate to the new URL AND reload
    window.location.href = link;
  };

  return (
    <li className="mega-menu-item">
      <a href={link} onClick={handleClick}>
        <span>{text}</span>
      </a>

      {!removeArrow && <FaAngleRight className="dd-arrow" />}
    </li>
  );
}

export default function Header() {
  const [language, setLanguage] = useState("English");
  const [openMenu, setOpenMenu] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navRef = useRef(null);
  const [openLoginDropdown, setOpenLoginDropdown] = useState(false);
  const { pathname } = useLocation();

  const [openSections, setOpenSections] = useState({});

  const toggleSection = (key) =>
    setOpenSections((prev) => ({ ...prev, [key]: !prev[key] }));

  const isHomePage = pathname === "/";
  const closeAllMenus = () => {
    setOpenMenu(null);
    setMobileOpen(false);
  };

  const toggleMenu = (menu) => {
    setOpenMenu((prev) => (prev === menu ? null : menu));
  };

  useEffect(() => {
    const handler = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        closeAllMenus();
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // ✅ stop page scroll when drawer open
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [mobileOpen]);

  return (
    <>
      <header
        className={` site-header ${
          isHomePage ? "bg-[#D1DFEA]" : "bg-[#d3e0eb]"
        }`}
      >
        <nav className="site-nav max-w-300" ref={navRef}>
          {/* Left */}
          <Link to="/" className="brand" onClick={closeAllMenus}>
            <img
              src="/waggex-logo.svg"
              alt="Waggex payroll software"
              width="160"
              height="50"
            />
          </Link>

          {/* Mobile Toggle */}
          <button
            className="menu-btn"
            onClick={() => setMobileOpen((s) => !s)}
            aria-label="Toggle menu"
            aria-expanded={mobileOpen}
          >
            ☰
          </button>

          {/* ✅ Backdrop (only mobile) */}
          <div
            className={`drawer-backdrop ${mobileOpen ? "is-open" : ""}`}
            onClick={closeAllMenus}
          />

          {/* ✅ Drawer Menu */}
          <aside className={`mobile-drawer ${mobileOpen ? "is-open" : ""}`}>
            <div className="drawer-top">
              <span className="drawer-title">Menu</span>
              <button className="drawer-close" onClick={closeAllMenus}>
                ✕
              </button>
            </div>

            <ul className="drawer-links">
              <li>
                <Link to="/" className="nav-link" onClick={closeAllMenus}>
                  Home
                </Link>
              </li>

              <li className="has-dd">
                <button
                  onClick={() => toggleMenu("services")}
                  className="nav-link nav-btn"
                >
                  Services <RiArrowDownSLine />
                </button>

                {openMenu === "services" && (
                  <ul className="dropdown dropdown--wide">
                    <SubItem
                      text="HRMS Software"
                      link="/hrms-software"
                      onNavigate={closeAllMenus}
                    />
                    <SubItem
                      text="Staff Attendance App"
                      link="/staff-attendance-app"
                      onNavigate={closeAllMenus}
                    />
                    <SubItem
                      text="Face Recognition Attendance"
                      link="/face-recognition-attendance-system"
                      onNavigate={closeAllMenus}
                    />
                    <SubItem
                      text="Live Location Tracking"
                      link="/employee-location-tracking-software"
                      onNavigate={closeAllMenus}
                    />
                    <SubItem
                      text="Face Lens App"
                      link="/facelens-app"
                      onNavigate={closeAllMenus}
                    />
                  </ul>
                )}
              </li>
              <li className="has-dd">
                <button
                  onClick={() => toggleMenu("features")}
                  className="nav-link nav-btn"
                  aria-expanded={openMenu === "features"}
                >
                  Features <RiArrowDownSLine />
                </button>

                {openMenu === "features" && (
                  <div className="dropdown dropdown--mega">
                    <ul className="mega-sections">
                      {/* HRMS Softwares */}
                      <li
                        className={`mega-section ${openSections.hrms ? "is-open" : ""}`}
                      >
                        <button
                          type="button"
                          className="mega-title"
                          onClick={() => toggleSection("hrms")}
                          aria-expanded={!!openSections.hrms}
                        >
                          HRMS Softwares
                          <RiArrowDownSLine className="mega-caret text-sm" />
                        </button>

                        <ul className="mega-list">
                          <SubItem
                            text="Payroll Management"
                            link="/payroll-management"
                            onNavigate={closeAllMenus}
                          />
                          <SubItem
                            text="Bonus Management"
                            link="/employee-bonus"
                            onNavigate={closeAllMenus}
                          />
                          <SubItem
                            text="Expense Management"
                            link="/expense-management"
                            onNavigate={closeAllMenus}
                          />
                          <SubItem
                            text="Loan & Advance Salary"
                            link="/loan-advance-management"
                            onNavigate={closeAllMenus}
                          />
                          <SubItem
                            text="Attendance"
                            link="/attendance-management"
                            onNavigate={closeAllMenus}
                          />
                          <SubItem
                            text="Shift Management"
                            link="/shift-management"
                            onNavigate={closeAllMenus}
                          />
                          <SubItem
                            text="Geo Attendance"
                            link="/geo-location-attendance"
                            onNavigate={closeAllMenus}
                          />
                          <SubItem
                            text="Selfie Based Attendance"
                            link="/selfie-based-attendance"
                            onNavigate={closeAllMenus}
                          />

                          <li className="mega-viewall-li">
                            <Link
                              to="/all-features"
                              className="mega-viewall"
                              onClick={closeAllMenus}
                            >
                              View All <FaArrowRight size={14} />
                            </Link>
                          </li>
                        </ul>
                      </li>

                      {/* Free HR Documents */}
                      <li
                        className={`mega-section ${openSections.docs ? "is-open" : ""}`}
                      >
                        <button
                          type="button"
                          className="mega-title"
                          onClick={() => toggleSection("docs")}
                          aria-expanded={!!openSections.docs}
                        >
                          Free HR Documents
                          <RiArrowDownSLine className="mega-caret" />
                        </button>

                        <ul className="mega-list">
                          <SubItem
                            text="Payslip Generator"
                            link="/hr-documents/payslip-generator"
                            onNavigate={closeAllMenus}
                          />
                          <SubItem
                            text="Offer Letter"
                            link="/hr-documents/offer-letter-generator"
                            onNavigate={closeAllMenus}
                          />
                          <SubItem
                            text="Appointment Letter"
                            link="/hr-documents/appointment-letter-generator"
                            onNavigate={closeAllMenus}
                          />
                          <SubItem
                            text="Experience Letter"
                            link="/hr-documents/experience-letter-generator"
                            onNavigate={closeAllMenus}
                          />
                          <SubItem
                            text="Relieving Letter"
                            link="/hr-documents/relieving-letter-generator"
                            onNavigate={closeAllMenus}
                          />
                          <SubItem
                            text="Promotion Letter"
                            link="/hr-documents/promotion-letter-generator"
                            onNavigate={closeAllMenus}
                          />
                          <SubItem
                            text="Salary Increment Letter"
                            link="/hr-documents/salaryincrement-letter-generator"
                            onNavigate={closeAllMenus}
                          />
                          <SubItem
                            text="Salary Revision Letter"
                            link="/hr-documents/salaryrevision-letter-generator"
                            onNavigate={closeAllMenus}
                          />
                          <li className="mega-viewall-li mb-3">
                            <Link
                              to="/all-hr-documents"
                              className="mega-viewall"
                              onClick={closeAllMenus}
                            >
                              View All <FaArrowRight size={14} />
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                )}
              </li>

              <li>
                <Link
                  to="/pricing"
                  className="nav-link"
                  onClick={closeAllMenus}
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link
                  to="/how-to-use"
                  className="nav-link"
                  onClick={closeAllMenus}
                >
                  How to Use
                </Link>
              </li>
              <li>
                <Link
                  to="https://www.waggex.com/blog/"
                  className="nav-link"
                  target="_blank"
                  onClick={closeAllMenus}
                >
                  Blog
                </Link>
              </li>

              {/* Auth buttons in drawer */}
              <li className="auth auth--mobile">
                <a
                  href="https://app.waggex.com/signup"
                  rel="canonical"
                  className="btn btn-outline"
                  onClick={closeAllMenus}
                >
                  Sign Up
                </a>

                <div className="has-dd">
                  <button
                    onClick={() => toggleMenu("login")}
                    className="btn btn-outline login-btn-outline"
                    type="button"
                  >
                    Log In <RiArrowDownSLine />
                  </button>

                  {openMenu === "login" && (
                    <ul className="dropdown login-dropdown--wide">
                      <SubItem
                        text="Employer Dashboard"
                        link="https://app.waggex.com/login"
                        onNavigate={closeAllMenus}
                        // removeArrow={false}
                      />

                      <SubItem
                        text="Employee Portal"
                        link="https://employee.waggex.com"
                        onNavigate={closeAllMenus}
                        // removeArrow={false}
                      />
                    </ul>
                  )}
                </div>
              </li>
            </ul>
          </aside>

          {/* ✅ Desktop Nav (unchanged) */}
          <ul className="nav-links nav-links--desktop">
            <li>
              <Link to="/" className="nav-link" onClick={closeAllMenus}>
                Home
              </Link>
            </li>

            <li className="has-dd">
              <button
                onClick={() => toggleMenu("services")}
                className="nav-link nav-btn"
              >
                Services <RiArrowDownSLine />
              </button>

              {openMenu === "services" && (
                <ul className="dropdown dropdown--wide">
                  <SubItem
                    text="HRMS Software"
                    link="/hrms-software"
                    onNavigate={closeAllMenus}
                  />
                  <SubItem
                    text="Staff Attendance App"
                    link="/staff-attendance-app"
                    onNavigate={closeAllMenus}
                  />
                  <SubItem
                    text="Face Recognition Attendance"
                    link="/face-recognition-attendance-system"
                    onNavigate={closeAllMenus}
                  />
                  <SubItem
                    text="Live Location Tracking"
                    link="/employee-location-tracking-software"
                    onNavigate={closeAllMenus}
                  />
                  <SubItem
                    text="Face Lens App"
                    link="/facelens-app"
                    onNavigate={closeAllMenus}
                  />
                </ul>
              )}
            </li>

            <li className="has-dd">
              <button
                onClick={() => toggleMenu("features")}
                className="nav-link nav-btn"
              >
                Features <RiArrowDownSLine />
              </button>
              {openMenu === "features" && (
                <div className="mega-menu">
                  <div className="mega-grid">
                    <div className="mega-column">
                      <h4>HRMS Softwares</h4>
                      <ul>
                        <MegaSubItem
                          text="Payroll Management"
                          link="/payroll-management"
                          onNavigate={closeAllMenus}
                        />
                        <MegaSubItem
                          text="Bonus Management"
                          link="/employee-bonus"
                          onNavigate={closeAllMenus}
                        />
                        <MegaSubItem
                          text="Expense Management"
                          link="/expense-management"
                          onNavigate={closeAllMenus}
                        />
                        <MegaSubItem
                          text="Loan & Advance Salary"
                          link="/loan-advance-management"
                          onNavigate={closeAllMenus}
                        />
                        <MegaSubItem
                          text="Attendance"
                          link="/attendance-management"
                          onNavigate={closeAllMenus}
                        />
                        <MegaSubItem
                          text="Shift Management"
                          link="/shift-management"
                          onNavigate={closeAllMenus}
                        />
                        <MegaSubItem
                          text="Geo Attendance"
                          link="/geo-location-attendance"
                          onNavigate={closeAllMenus}
                        />
                        <MegaSubItem
                          text="Selfie Based Attendance"
                          link="/selfie-based-attendance"
                          onNavigate={closeAllMenus}
                        />
                      </ul>
                      <Link
                        to="/all-features"
                        className="mt-2 mega-view-all inline-flex items-center gap-2"
                        onClick={() => {
                          closeAllMenus();
                        }}
                      >
                        View All <FaArrowRight size={14} />
                      </Link>
                    </div>

                    <div className="mega-column">
                      <h4>Free HR Documents</h4>
                      <ul>
                        <MegaSubItem
                          text="Payslip Generator"
                          link="/hr-documents/payslip-generator"
                          onNavigate={closeAllMenus}
                        />
                        <MegaSubItem
                          text="Offer Letter"
                          link="/hr-documents/offer-letter-generator"
                          onNavigate={closeAllMenus}
                        />
                        <MegaSubItem
                          text="Appointment Letter"
                          link="/hr-documents/appointment-letter-generator"
                          onNavigate={closeAllMenus}
                        />
                        <MegaSubItem
                          text="Experience Letter"
                          link="/hr-documents/experience-letter-generator"
                          onNavigate={closeAllMenus}
                        />
                        <MegaSubItem
                          text="Relieving Letter"
                          link="/hr-documents/relieving-letter-generator"
                          onNavigate={closeAllMenus}
                        />
                        <MegaSubItem
                          text="Promotion Letter"
                          link="/hr-documents/promotion-letter-generator"
                          onNavigate={closeAllMenus}
                        />
                        <MegaSubItem
                          text="Salary Increment Letter"
                          link="/hr-documents/salaryincrement-letter-generator"
                          onNavigate={closeAllMenus}
                        />
                        <MegaSubItem
                          text="Salary Revision Letter"
                          link="/hr-documents/salaryrevision-letter-generator"
                          onNavigate={closeAllMenus}
                        />
                      </ul>
                      <Link
                        to="/all-hr-documents"
                        className="mt-2 mega-view-all inline-flex items-center gap-2"
                        onClick={() => {
                          closeAllMenus();
                        }}
                      >
                        View All <FaArrowRight size={14} />
                      </Link>
                    </div>
                  </div>
                </div>
              )}
            </li>

            <li>
              <Link
                to="/pricing"
                className="nav-link nav-btn"
                onClick={closeAllMenus}
              >
                Pricing
              </Link>
            </li>
            <li>
              <Link
                to="/how-to-use"
                className="nav-link"
                onClick={closeAllMenus}
              >
                How to Use
              </Link>
            </li>
            <li>
              <Link
                to="https://www.waggex.com/blog/"
                className="nav-link"
                target="_blank"
                onClick={closeAllMenus}
              >
                Blog
              </Link>
            </li>

            {/* <li className="has-dd">
            <button
              onClick={() => toggleMenu("language")}
              className="nav-link nav-btn"
            >
              {language} <RiArrowDownSLine />
            </button>

            {openMenu === "language" && (
              <ul className="dropdown dropdown--small">
                {["English", "Hindi", "Gujarati", "Marathi", "Punjabi"].map(
                  (lang) => (
                    <SubItemSelect
                      key={lang}
                      text={lang}
                      onClick={() => {
                        setLanguage(lang);
                        closeAllMenus();
                      }}
                    />
                  ),
                )}
              </ul>
            )}
          </li> */}

            {/* Auth buttons in drawer */}
            <li className="auth auth--mobile">
              <a
                href="https://app.waggex.com/signup"
                className="btn btn-outline rounded-xl"
                onClick={closeAllMenus}
              >
                Sign Up
              </a>
              {/* <a
              href="https://app.waggex.com/login"
              className="btn btn-soft"
              onClick={closeAllMenus}
            >
              Log In
            </a> */}

              <div className="dropdown">
                <button className="btn dropdown-toggle">Login ▾</button>

                <div className="dropdown-menu">
                  <a
                    href="https://app.waggex.com/login"
                    className="dropdown-item"
                    onClick={closeAllMenus}
                  >
                    Employer Dashboard
                  </a>

                  <a
                    href="https://employee.waggex.com"
                    className="dropdown-item"
                    onClick={closeAllMenus}
                  >
                    Employee Portal
                  </a>
                </div>
              </div>
            </li>
            {/* keep your desktop dropdowns here as before if you want */}
          </ul>

          <div className="auth auth--desktop">
            <a href="https://app.waggex.com/signup" className="btn btn-outline">
              Sign Up
            </a>
            {/* <a href="https://app.waggex.com/login" className="btn btn-soft">
            Log In
          </a> */}

            {/* <div className="dropdown login-dropdown">
            <button className="btn btn-soft dropdown-toggle">Log In ▾</button>

            <div className="dropdown-menu">
              <a
                href="https://app.waggex.com/login"
                className="dropdown-item"
                onClick={closeAllMenus}
              >
                Employer Dashboard
              </a>

              <a
                href="https://employee.waggex.com/"
                className="dropdown-item"
                onClick={closeAllMenus}
              >
                Employee Portal
              </a>
            </div>
          </div> */}

            <div className="has-dd">
              <button
                onClick={() => toggleMenu("login")}
                className="btn btn-soft nav-btn"
                type="button"
              >
                Login <RiArrowDownSLine />
              </button>

              {openMenu === "login" && (
                <ul className="dropdown login-dropdown--wide">
                  <SubItem
                    text="Employer Dashboard"
                    link="https://app.waggex.com/login"
                    onNavigate={closeAllMenus}
                    // removeArrow={true}
                  />

                  <SubItem
                    text="Employee Portal"
                    link="https://employee.waggex.com/login"
                    onNavigate={closeAllMenus}
                    // removeArrow={true}
                  />
                </ul>
              )}
            </div>
          </div>
        </nav>
      </header>
    </>
  );
}
